<template>
  <div class="mb-3">
    <b-row class="border-bottom pb-2 mb-2">
      <b-col>
        <img src="img/brand/logo.png" class="result_detail_logo">
      </b-col>

      <b-col>
        <h2 class="font-weight-normal">Crop Monitoring</h2>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
				Report #: <br>
				Report Date: <br>
				Project: <br>
				Field Code: {{ field }}<br>
        Field ID: <br>
			</b-col>

      <b-col>
				Grower #: {{ grower }}<br>
				Crop: <br>
				Variety: <br>
				Land Loc: <br>
			</b-col>

      <b-col class="text-right">
				Down to Earth Labs<br>
			</b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'TimeSeriesReportHeader',
  props: {
    report: {
      type: Object,
      default: () => {
        return {}
      },
    }
  },
  computed: {
    grower () {
      const growerFilter = this.report.params.filters.find(filter => filter.field === 'grower')
      return growerFilter && growerFilter.value || 'N/A'
    },
    field () {
      const fieldFilter = this.report.params.filters.find(filter => filter.field === 'field')
      return fieldFilter && fieldFilter.value || 'N/A'
    }
  }
}
</script>
